module.exports = __webpack_public_path__ + "static/img/logo.c28cf8bd.png";